import React, { useState } from 'react';
import { makeStyles, Grid, Button, Box } from '@material-ui/core';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { SERVICES_CODES } from 'app/config/services';
import { STATUS_CODES } from 'app/config/status';

import styles from './styles';
const useStyles = makeStyles(styles);

function FinalizeButton({ mainColor, hideFinalizeBtn, isInternalForm, canEdit, onSubmit }) {
  const classes = useStyles();

  const service = useSelector(state => state.services.details);
  const request = useSelector(state => state.requests.details);

  const [showFinalizeButton] = useState(() => {
    if (hideFinalizeBtn) return false;
    if (isInternalForm) return canEdit;
    if (!canEdit) {
      if (
        service.cdServico === SERVICES_CODES.INATIVACAO_CADASTRAL ||
        service.cdServico === SERVICES_CODES.EXCLUSAO_VEICULOS
      ) {
        if (!request.situacao) return true; // new request
        return (
          request.situacao?.boEdicaoPortalExterno ||
          request.cdSituacao === STATUS_CODES.EM_CONSTRUCAO
        );
      }
    }
    return canEdit;
  });

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <>
      {showFinalizeButton && (
        <Grid container spacing={3} className={classes.finalizeContainer}>
          <Button
            disableElevation
            type="submit"
            variant="contained"
            color={mainColor ? mainColor : 'primary'}
            className={classes.finalizeBtn}
            onClick={() => handleSubmit()}
          >
            <Box className={classes.colorWhite}>
              <FormattedMessage id="LABELS.SERVICES.FINALIZE_REQUEST" />
            </Box>
          </Button>
        </Grid>
      )}
    </>
  );
}

export default injectIntl(FinalizeButton);
